import { BaseSysCalls } from './BaseSysCalls';
import { Lightning, Log } from '@lightningjs/sdk';

export class WebSysCalls extends BaseSysCalls {
  static override exitApp(element: Lightning.Component) {
    if (element) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      element.application.closeApp();
    } else Log.error('no element passed to exitApp');
  }

  static override init() {
    super.init();
    // also add playback restart on internet disconnect for web
    this.addOnlineOfflineVideoHandlers();
  }

  static override platformVersion() {
    return 'unknown';
  }

  static override modelName() {
    return 'Web browser';
  }
}
